
import Vue from "vue";

import TableCustom from "@/components/TableCustom.vue";
import { FormAlarmSectionAllEnum } from "../../enums/FormAlarmSectionAllInputEnum";

export default Vue.extend({
  name: "FormAlarmLimitSensor",
  components: { TableCustom },
  computed: {
    FormAlarmSectionAllEnum() {
      return FormAlarmSectionAllEnum;
    },
    items: {
      get() {
        return this.$store.state.updateModelForm.mca_alarm_limit_sensor_new;
      },
    },
    filteredItems() {
      return (this as any).items.filter((item: any) => {
        return item.sensorGroupId === this.healthMonitoringType;
      });
    },
    modelType() {
      return this.$store.getters.model.modelTypeId;
    },
  },
  data() {
    const headerTransformer = [
      { text: "Sensor name", value: "sensorName", sortable: false, width: "30%" },
      { text: "Unit", value: "unit", sortable: false, width: "20%" },
      { text: "Warning", value: "warning", sortable: false, width: "20%" },
      { text: "Alarm", value: "alarm", sortable: false, width: "20%" },
      { text: "Criteria", value: "criteria", sortable: false, width: "10%" },
    ];

    const headerMCA = [
      {
        text: "Tick for monitor",
        align: "center",
        sortable: false,
        value: "",
        width: "20%",
      },
      {
        text: "Tick for alert",
        align: "center",
        sortable: false,
        value: "",
        width: "20%",
      },
      {
        text: "Sensor Name",
        align: "start",
        sortable: false,
        value: "modelConfigurationTag.title",
        width: "20%",
      },
      {
        text: "Warning",
        align: "center",
        sortable: false,
        value: "warning",
        width: "20%",
      },
      {
        text: "Alarm",
        align: "center",
        sortable: false,
        value: "alarm",
        width: "20%",
      },
      {
        text: "RUL Warning",
        align: "center",
        sortable: false,
        value: "rul_warning",
        width: "20%",
      },
      {
        text: "RUL Alarm",
        align: "center",
        sortable: false,
        value: "rul_alarm",
        width: "20%",
      },
    ];

    const sectionApplyAll = {
      isMonitorChecked: true,
      isAlertChecked: false,
      sensorNameInput: "",
      warningInput: 0,
      alarmInput: 0,
      rulWarningInput: 0,
      rulAlarmInput: 0,
    };

    return {
      headerTransformer,
      headerMCA,
      healthMonitoringType: 1,
      healthMonitoringSensorType: 1,
      healthMonitoringTypeItems: [],
      healthMonitoringSensorTypeItems: [],
      sectionApplyAll,
      updateItems: [],
    };
  },
  async created() {
    await this.fetchHealthMonitoringType();
  },
  methods: {
    async fetchHealthMonitoringType() {
      try {
        const res = await Vue.prototype.$dep.modelUseCase.getAlarmLimitGroup();
        const data = res.filter((val) => val.equipmentModelTypeId == this.modelType);

        this.healthMonitoringType = data[0].id;
        this.healthMonitoringTypeItems = data.map((row: any) => ({ id: row.id, name: row.name }));
      } catch (error) {
        this.healthMonitoringTypeItems = [];
      }
    },

    onUpdateState(event, row, columnName) {
      // If click checkbox in  columnName  = isSelect
      if (columnName === "isSelect") {
        this.$store.dispatch("setUpdateModelForm", {
          ...this.$store.state.updateModelForm,
          mca_alarm_limit_sensor_new: this.items.map((item: any) => ({
            ...item,
            isSelect: item.isSelect,
            isAlert:
              +this.healthMonitoringType === +item.sensorGroupId
                ? item.isSelect === false && item.isAlert === true
                  ? false
                  : item.isAlert
                : item.isAlert,
            alarm: +item.alarm,
            warning: +item.warning,
            rulWarning: +item.rulWarning,
            rulalarm: +item.rulalarm,
          })),
        });

        // If click checkbox in  columnName  = isAlert
      } else if (columnName === "isAlert") {
        console.log("if isAlert");
        this.$store.dispatch("setUpdateModelForm", {
          ...this.$store.state.updateModelForm,
          mca_alarm_limit_sensor_new: this.items.map((item: any) => ({
            ...item,
            isSelect:
              +this.healthMonitoringType === +item.sensorGroupId
                ? item.isAlert === true && item.isSelect === false
                  ? true
                  : item.isSelect
                : item.isSelect,
            isAlert: item.isAlert,
            alarm: +item.alarm,
            warning: +item.warning,
            rulWarning: +item.rulWarning,
            rulalarm: +item.rulalarm,
          })),
        });
      } else {
        this.$store.dispatch("setUpdateModelForm", {
          ...this.$store.state.updateModelForm,
          mca_alarm_limit_sensor_new: this.items.map((item: any) => ({
            ...item,
            alarm: +item.alarm,
            warning: +item.warning,
            rulWarning: +item.rulWarning,
            rulalarm: +item.rulalarm,
          })),
        });
      }
    },

    onSelectAll(props: { items: any[]; value: boolean }) {
      const { items, value } = props;

      const x = Object.fromEntries(items.map((o) => [o.id, { ...o, isSelect: value }]));
      const result = this.items.map((o: any) => x[o.id] || o);

      this.$store.dispatch("setUpdateModelForm", {
        ...this.$store.state.updateModelForm,
        mca_alarm_limit_sensor_new: result,
      });
    },
    onChangeManageAllInput(eventValue: string | boolean, inputName: string) {
      if (inputName === FormAlarmSectionAllEnum.MONITOR_CHECKBOX) {
        const value = eventValue;

        this.updateItems = this.items.map((item: any) => ({
          ...item,
          isSelect: +item.sensorGroupId === +this.healthMonitoringType ? value : item.isSelect,
          isAlert: +item.sensorGroupId === +this.healthMonitoringType ? value : item.isAlert,
        }));
      }

      if (inputName === FormAlarmSectionAllEnum.ALERT_CHECKBOX) {
        const value = eventValue;
        this.updateItems = this.items.map((item: any) => ({
          ...item,
          isAlert: +item.sensorGroupId === +this.healthMonitoringType ? value : item.isAlert,
        }));

        //if check all alert is true then all mornitor also check true
        // if (value === true) {
        //   this.updateItems = this.items.map((item: any) => ({
        //     ...item,
        //     isSelect: +item.sensorGroupId === +this.healthMonitoringType ? value : item.isSelect,
        //     isAlert: +item.sensorGroupId === +this.healthMonitoringType ? value : item.isAlert,
        //   }));
        // }
      }

      if (inputName === FormAlarmSectionAllEnum.SENSOR_NAME_INPUT) {
        const value = eventValue;
        this.updateItems = this.items.map((item: any) => ({
          ...item,
          name: +item.sensorGroupId === +this.healthMonitoringType ? value : item.name,
        }));
      }

      if (inputName === FormAlarmSectionAllEnum.WARNING_INPUT) {
        const value = eventValue;
        this.updateItems = this.items.map((item: any) => ({
          ...item,
          warning: +item.sensorGroupId === +this.healthMonitoringType ? value : +item.warning,
        }));
      }
      if (inputName === FormAlarmSectionAllEnum.ALARM_INPUT) {
        const value = eventValue;
        this.updateItems = this.items.map((item: any) => ({
          ...item,
          alarm: +item.sensorGroupId === +this.healthMonitoringType ? value : +item.alarm,
        }));
      }

      if (inputName === FormAlarmSectionAllEnum.RUL_WARNING_INPUT) {
        const value = eventValue;
        this.updateItems = this.items.map((item: any) => ({
          ...item,
          rulWarning: +item.sensorGroupId === +this.healthMonitoringType ? value : +item.rulWarning,
        }));
      }

      if (inputName === FormAlarmSectionAllEnum.RUL_ALARM_INPUT) {
        const value = eventValue;
        this.updateItems = this.items.map((item: any) => ({
          ...item,
          rulalarm: +item.sensorGroupId === +this.healthMonitoringType ? value : +item.rulalarm,
        }));
      }

      this.$store.dispatch("setUpdateModelForm", {
        ...this.$store.state.updateModelForm,
        mca_alarm_limit_sensor_new: this.updateItems,
      });
    },
  },
  watch: {
    filteredItems() {
      // console.log(
      //   "type::",
      //   typeof this.items,
      //   this.items.filter((item: any) => {
      //     return item.sensorGroupId === this.healthMonitoringType;
      //   })
      // );
      // for alert checkbox
      const isSomeAlertNotSelected = this.items
        .filter((item: any) => {
          return item.sensorGroupId === this.healthMonitoringType;
        })
        .some((item: any) => item.isAlert === false);

      // For monitor checkbox
      const isSomeMonitorNotSelected = this.items
        .filter((item: any) => {
          return item.sensorGroupId === this.healthMonitoringType;
        })
        .some((item: any) => item.isSelect === false);

      if (isSomeAlertNotSelected) {
        this.sectionApplyAll.isAlertChecked = false;
      } else {
        this.sectionApplyAll.isAlertChecked = true;
      }

      if (isSomeMonitorNotSelected) {
        this.sectionApplyAll.isMonitorChecked = false;
      } else {
        this.sectionApplyAll.isMonitorChecked = true;
      }
    },
    healthMonitoringType() {
      // Default alert tick
      // if (
      //   this.healthMonitoringType === McaFormAlarmLimitSensorTypeEnum.CURRENT ||
      //   this.healthMonitoringType === McaFormAlarmLimitSensorTypeEnum.SPEED ||
      //   this.healthMonitoringType === McaFormAlarmLimitSensorTypeEnum.BEARING ||
      //   this.healthMonitoringType === McaFormAlarmLimitSensorTypeEnum.DIAGNOSTIC
      // ) {
      //   this.sectionApplyAll.isAlertChecked = false;
      // } else {
      //   this.sectionApplyAll.isAlertChecked = true;
      // }
      // Default for warning and alarm input
      // if (this.healthMonitoringType === McaFormAlarmLimitSensorTypeEnum.CURRENT_UNBALANCE) {
      //   this.sectionApplyAll.warningInput = 6;
      //   this.sectionApplyAll.alarmInput = 10;
      // } else {
      //   this.sectionApplyAll.warningInput = 0;
      //   this.sectionApplyAll.alarmInput = 0;
      // }
      // Default all types
      // this.sectionApplyAll.isMonitorChecked = true;
      // this.sectionApplyAll.sensorNameInput = "";
      // this.sectionApplyAll.rulWarningInput = 0;
      // this.sectionApplyAll.rulAlarmInput = 0;
    },
  },
});
